import { NoSidebar } from "modules/self-apply/layouts/no-sidebar";
import { HStack } from "@/components/composition/stack.layout";
import { GenericLoadingBounce } from "@/components/generic-loading";

import { EmptySelfApplyHeader } from "./empty";

export const LoadingCareersPage = () => {
  return (
    <NoSidebar.Container>
      <NoSidebar.Header>
        <EmptySelfApplyHeader />
      </NoSidebar.Header>
      <NoSidebar.Content>
        <HStack className="justify-center items-center w-full">
          <GenericLoadingBounce message="Loading..." />
        </HStack>
      </NoSidebar.Content>
    </NoSidebar.Container>
  );
};
